var $ = require('jquery');


class AppManager {
	constructor() {
		this.main = {
			layout: $('div#container')
		}
		this._writePlayerVersion();
	}

	_writePlayerVersion() {
		window.playerVersion = 1.1;
	}

}

module.exports = new AppManager();


// WEBPACK FOOTER //
// ./app/app-manager.js